/*
api-envelope.js

Parser for the recipe_backend v2 response envelope: { data, error }.
- error is { code, message } with stable codes (MISSING_PARAMETER, INVALID_INPUT,
  USER_NOT_FOUND, RECIPE_NOT_FOUND, FORBIDDEN, INTERNAL_ERROR).
- Frontend opts into v2 by appending ?v=2 (handled in Constants.generateSecureApiUrl).
- A response body that is an envelope can ride on HTTP 2xx OR non-2xx; envelope check
  runs first so the /share?mode=fromLink invalid-guid case (HTTP 200 with error envelope)
  is handled correctly.
- Non-envelope 2xx responses (e.g., Auth0 /userinfo) pass through unchanged.
*/

export class APIError extends Error {
  constructor(code, message) {
    super(message);
    this.name = "APIError";
    this.code = code;
  }
}

function isEnvelope(body) {
  return (
    body !== null &&
    typeof body === "object" &&
    !Array.isArray(body) &&
    Object.prototype.hasOwnProperty.call(body, "data") &&
    Object.prototype.hasOwnProperty.call(body, "error")
  );
}

export function parseEnvelope(body, status) {
  if (isEnvelope(body)) {
    if (body.error) {
      const code = body.error.code || "UNKNOWN";
      const message = body.error.message || "Unknown error";
      throw new APIError(code, message);
    }
    // Reject success envelopes that ride on a non-2xx status — server bug.
    if (status < 200 || status >= 300) {
      throw new APIError("UNKNOWN", "HTTP " + status);
    }
    return body.data;
  }

  if (status >= 200 && status < 300) {
    return body;
  }

  throw new APIError("UNKNOWN", "HTTP " + status);
}
